export function byLastName<T extends { name: { last: string } }>(a: T, b: T): number {
  if (a.name.last.toLowerCase() < b.name.last.toLowerCase()) {
    return -1;
  }
  if (a.name.last.toLowerCase() > b.name.last.toLowerCase()) {
    return 1;
  }
  return 0;
}
